import _ from "underscore";

export function flatNodes(node, childrenProp = "children", includeParents = false) {
    const result = [];

    function traverse(res, children) {
        if (_.isArray(children)) {
            children.forEach(child => {
                if (_.isArray(child[childrenProp])) {
                    if (includeParents) {
                        res.push(child);
                    }
                    traverse(res, child[childrenProp]);
                } else {
                    res.push(child);
                }
            })
        }
    }

    if (_.isArray(node[childrenProp])) {
        if (includeParents) {
            result.push(node);
        }
        traverse(result, node[childrenProp]);
    } else {
        result.push(node);
    }

    return result;
}